export const validatePassword = (value) => {
  let errorMessage = '';
  if (!value) {
    return;
  }

  value = value.trim();
  if (/[\sа-я]+/i.test(value)) {
    errorMessage = 'Use latin characters and special symbols except spaces';
  } else if (value.length < 8) {
    errorMessage = 'Password is too short, please use at least 8 characters';
  } else if (value.length > 30) {
    errorMessage = 'Password is too long, please use no more than 30 characters';
  }

  return errorMessage;
};
